<template>
  <vs-tooltip :interactivity="true" class="extrasTooltip">
    <div v-if="extras.length" class="extra-indicator">{{ extras.length }}</div>
    <template #tooltip>
      <div class="content-tooltip">
        <h4>
          Extras
        </h4>
        <div class="extras-wrapper">
          <vue-custom-scrollbar class="scroll-area" :settings="settings">
            <ul>
              <li v-for="(extra,index) in extras" :key="unitID+'1'+index">
                {{ extra['Stored Description'] }}
              </li>
            </ul>
          </vue-custom-scrollbar>
        </div>
      </div>
    </template>
  </vs-tooltip>
</template>

<script>
import axios from "axios";
import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
  name: "ExtrasTooltip",
  props: {
    unitID: String,
    scheduleLiveAreaTaskID: String,
  },
  components: {
    vueCustomScrollbar,
  },
  data: function () {
    return {
      extras: [],
      settings: {
        suppressScrollY: false,
        suppressScrollX: true,
        wheelPropagation: false
      },
    };
  }
  ,
  mounted() {

    this.getExtras()
        .then((extras) => {
          this.extras = extras
        })
        .catch(err => {
          console.log('err when getting extras', err)
          if (err === 'authToken expired') {
            this.logout()
          }
        })

  }
  , methods: {
    getExtras() {

      return new Promise((resolve, reject) => {
        axios({
          url: 'https://admin.giraffapp.com/giraffweb_get_extras?unitID=' + this.unitID + '&scheduleLiveAreaTaskID=' + this.scheduleLiveAreaTaskID + '&authToken=' + this.authToken,
          method: 'GET'
        }).then(resp => {
          // console.log('getExtrasForTask resp', resp)
          if (resp.data.result) {
            // console.log('extras', resp.data.details.Customizations)
            if (resp.data.details.Customizations) {
              resolve(resp.data.details.Customizations.filter(extra => {
                return !extra['Stored Description'].includes('Base Contract')
              }))
            } else {
              reject('authToken expired')
            }


            // resolve(resp.data.details.Customizations)
          } else {
            resolve([])
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    logout: function () {
      this.$store.dispatch('logout')
          .then(() => {
            this.$router.push('/login')
          })
    }
  },
  computed: {
    authToken: function () {
      return this.$store.getters.authToken
    }
  }
}
</script>

<style scoped lang="sass">
.scroll-area
  max-height: 300px
  position: relative
  overflow: auto

  ul
    text-align: left

    li
      font-size: 12px
</style>
